module.exports = __webpack_public_path__ + "img/Group 687four.63618b9c.png";